import { render, staticRenderFns } from "./PastPerformanceModal.html?vue&type=template&id=bf57e8c2&external"
import script from "./PastPerformanceModal.ts?vue&type=script&lang=ts&external"
export * from "./PastPerformanceModal.ts?vue&type=script&lang=ts&external"
import style0 from "./PastPerformanceModal.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports